var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"myEchart",staticStyle:{"width":"98%","height":"98%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }